// Indonesian texts for Website tools (single page downloader).
export default {
  "Website tools": "Alat website",
  "Clone website": "Clone Website",
  "Download one live page with its own CSS, JavaScript, images and fonts. Other pages and external CDNs are not downloaded.":
    "Unduh satu halaman website yang masih aktif, lengkap dengan CSS, JavaScript, gambar, dan font miliknya. Halaman lain dan CDN luar tidak diunduh.",
  "New download": "Unduhan baru",
  "Page URL": "URL halaman",
  "Only this page is downloaded, with the files it needs from the same website. Only copy pages you own or may use.":
    "Hanya halaman ini yang diunduh, beserta file yang dibutuhkannya dari website yang sama. Salin hanya halaman milikmu atau yang boleh kamu pakai.",
  "Project name": "Nama proyek",
  "Keep the original HTML": "Simpan HTML asli",
  "original.html is saved exactly as the server sent it.": "original.html disimpan persis seperti yang dikirim server.",
  "Only files from the same host": "Hanya file dari host yang sama",
  "CDNs and other subdomains stay online and are not downloaded.": "CDN dan subdomain lain tetap online dan tidak diunduh.",
  "Also allow these hosts (optional)": "Izinkan juga host ini (opsional)",
  "Create preview.html": "Buat preview.html",
  "A copy that loads the downloaded files, for checking the result.": "Salinan yang memakai file hasil unduhan, untuk mengecek hasilnya.",
  "Download images and fonts used in CSS": "Unduh gambar dan font yang dipakai di CSS",
  "Backgrounds, icons and web fonts referenced by the stylesheets.": "Gambar latar, ikon, dan web font yang disebut di file CSS.",
  "Limits": "Batasan",
  "Maximum size (MB)": "Ukuran maksimal (MB)",
  "Timeout per file (s)": "Batas waktu per file (detik)",
  "Maximum files": "Jumlah file maksimal",
  "Start Download": "Mulai Unduh",
  "No downloads yet": "Belum ada unduhan",
  "Enter a page URL to start.": "Masukkan URL halaman untuk mulai.",
  "Download started": "Unduhan dimulai",
  "Download started again": "Unduhan dimulai ulang",
  "Download cancelled": "Unduhan dibatalkan",
  "Download deleted": "Unduhan dihapus",
  "Delete this download and its files?": "Hapus unduhan ini beserta file-nya?",
  "Downloading": "Mengunduh",
  "Generating preview": "Membuat pratinjau",
  "Packaging": "Membuat ZIP",
  "Partly downloaded": "Terunduh sebagian",
  "The download stopped": "Unduhan berhenti",
  "Some assets could not be downloaded. The preview may look incomplete; see the list below.":
    "Beberapa file tidak bisa diunduh. Pratinjau mungkin tidak lengkap; lihat daftar di bawah.",
  "Assets found": "File ditemukan",
  "Size": "Ukuran",
  "Elapsed": "Waktu berjalan",
  "External, left online": "Eksternal, tetap online",
  "References to other hosts (CDNs, Google Fonts, analytics) are not downloaded and keep pointing to the internet.":
    "Referensi ke host lain (CDN, Google Fonts, analytics) tidak diunduh dan tetap mengarah ke internet.",
  "Files were deleted from the server.": "File sudah dihapus dari server.",
  "Files are deleted from the server {when}.": "File dihapus dari server {when}.",
  "Logs": "Log",
  "Not downloaded ({n})": "Tidak terunduh ({n})",
  "Download history": "Riwayat unduhan",
  "Project": "Proyek",
  "Date": "Tanggal",
  "Actions": "Aksi",
} as Record<string, string>;
